import { memo, useCallback } from "react";
import { classNames, transformRoute, useTranslate } from "helpers";

import { TableRowChildProps } from "ui/components/Table/TableSearch/types";
import { TIRE_TYPE_BACKGROUND } from "../consts";
import { useNavigate } from "react-router-dom";
import { Routes as FleetTireRoutes } from "ui/modules/fleet/tires/navigation";
import { ReactSVG } from "react-svg";

const TireRowChild: React.FC<TableRowChildProps> = (props) => {
  const { index, row } = props;

  const { t } = useTranslate();
  const navigate = useNavigate();

  const handleRowClick = useCallback(
    (rowId: string) => (event: React.MouseEvent<unknown>) => {
      event.stopPropagation();
      event.preventDefault();

      navigate(
        transformRoute(FleetTireRoutes.FleetTireDetailPageRouter, {
          id: rowId,
        })
      );
    },
    [navigate]
  );

  return (
    <>
      <tr
        key={index}
        className={classNames(
          `cursor-pointer border border-slate-200 bg-amber-50 hover:bg-slate-100 relative text-slate-900` // Animacija sa delay-om
        )}
        onClick={handleRowClick(row.id)}
      >
        <td className="w-14 text-center ">
          <div className="flex items-center justify-center"></div>
        </td>
        <td className={classNames("px-4 py-3 text-sm font-medium ")}>
          <div className="flex justify-center items-center w-12">
            {TIRE_TYPE_BACKGROUND(row.tireType.code)}
          </div>
        </td>
        <td className={classNames("px-4 py-3 text-sm font-medium")}>
          <div className="flex items-center gap-1">
            <div>
              <ReactSVG
                src={"/media/icons/tire.svg"}
                className="w-3 stroke-[#667085]"
              />
            </div>
            <div> {row.name}</div>
          </div>
        </td>

        <td className={classNames("px-4 py-3 text-sm font-medium")}>
          {row.manufacturer?.name}
        </td>
        <td className={classNames("px-4 py-3 text-sm font-medium")}>
          {row.width}/{row.height}/{row.radius}
        </td>
        <td className={classNames("px-4 py-3 text-sm font-medium")}>
          {row.tireType?.name}
        </td>
        <td className={classNames("px-4 py-3 text-sm font-medium")}>
          {row.dot}
        </td>
        <td className={classNames("px-4 py-3 text-sm font-medium")}>
          {row.profileDepth && `${row.profileDepth} cm`}
        </td>
      </tr>
    </>
  );
};

export default memo(TireRowChild);
